import React, {PropTypes} from 'react';

const Authorize = ({
  authorized,
  children
}) => (
  <div className="animated fadeIn banner-flex-right">
    {authorized
      ? children
      : null
    }
  </div>
);

Authorize.propTypes = {
  authorized: PropTypes.bool,
  children: PropTypes.node
};

Authorize.defaultProps = {
  authorized: false,
  children: null
};

export default Authorize;



// WEBPACK FOOTER //
// ./src/features/shared/auth/Authorize.jsx